import * as Factory from 'factory.ts'
import faker from 'faker'

import { type ExportFormat } from '@webapp/platform/_unmigrated/Exporter/types'
import { ExporterColumnMock } from './exporterColumn.factory'

export const ExportFormatMock = Factory.Sync.makeFactory<ExportFormat>({
  columns: Factory.each(() => ExporterColumnMock.buildList(5)),
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.lorem.words(2)),
  date_format: null,
  decimal_point: null,
  is_default: false,
  type: null,
})
